import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Modal, {
  ModalBody,
  ModalHeader,
} from '../../../../components/modal/Modal';
import { translate } from '../../../../utils/translate/translations';
import BodyCompare from './BodyCompare';
import { useParams } from 'react-router-dom';
import useCompareModalScrolling from '../../../../components/compareManager/useCompareModalScrolling';
import fetchCapabilities from '../../../../api/fetchCapabilities';
import { useModelInfo } from '../../../../common/ModelInfoContext';
import LoadingSpecsCompare from '../../../../common/loading/LoadingSpecsCompare';
import makeCancellable from '../../../../common/makeCancellable';

const BodyCompareModal = ({
  config,
  matrix,
  features,
  onClose,
  appResources,
  onChange,
  isUpdating,
}) => {
  const { bodyStyleTitle } = appResources;
  const { id } = useParams();
  const [contentRef, setContentRef] = useState(null);
  const [capabilities, setCapabilities] = useState();
  const modelInfo = useModelInfo();

  useEffect(() => {
    const { cancel, promise: capabilitiesPromise } = makeCancellable(
      fetchCapabilities(modelInfo)
    );

    capabilitiesPromise
      .then((capabilitiesData) => setCapabilities(capabilitiesData))
      .catch((err) => {});

    return () => {
      cancel();
    };
  }, []);

  const header = translate('compare.specs.title.v3', {
    title: bodyStyleTitle,
  });
  const analyticsKey = 'compare body';

  const onSelect = (bodyType) => {
    onChange(bodyType);
    onClose();
  };

  const [scrolling] = useCompareModalScrolling(
    contentRef && contentRef.querySelector('.body-compare__modal-body')
  );

  return (
    <Modal
      isOpen={true}
      contentLabel={header}
      onRequestClose={onClose}
      contentRefCallback={(node) => setContentRef(node)}>
      <ModalHeader
        text={header}
        analyticsKey={bodyStyleTitle}
        onClose={onClose}
      />
      <ModalBody
        className="body-compare__modal-body"
        innerClassName="compare__nav-padding">
        {capabilities ? (
          <BodyCompare
            config={config}
            trimMatrix={matrix}
            features={features}
            onClose={onClose}
            appResources={appResources}
            selectedBodyTypeId={+id}
            analyticsKey={analyticsKey}
            onSelect={onSelect}
            isScrolled={scrolling}
            isUpdating={isUpdating}
            capabilities={capabilities}
          />
        ) : (
          <LoadingSpecsCompare />
        )}
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { appResources } = state;

  return {
    appResources,
  };
};

export default connect(mapStateToProps)(BodyCompareModal);
